<template>
  <div class="home">
    <Header />
    <Lead />
    <List />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Lead from '@/components/Lead.vue';
import List from '@/components/List.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  props: {
    p: {
      type: String,
    },
  },
  components: {
    Header,
    Lead,
    List,
    Footer,
  },
};
</script>
